import React, {useMemo} from 'react';
import '../styles/common.css';
import TextLoop from "react-text-loop/es";

const shuffle = ([...array]) => {
    for (let i = array.length - 1; i >= 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
};

function Footer(props) {
    const newMessages = useMemo(() => {
        const messages = shuffle(props.tougunMessages.concat(props.seigunMessages)).map((elm) => {
                return elm.text + "  (" + elm.name + "さん）";
            });
        return messages
    }, [props]);

    return (
        <div className="footer">
            <TextLoop key={newMessages.length} children={newMessages}/>
        </div>
    );
}

export default Footer;